import oAuthRequest from "./oauthRequest";

export const me = () => {
  return oAuthRequest.get('/api/v1/users/me')
}

export const index = () => {
  return oAuthRequest.get('/api/v1/users')
}

export const create = (body) => {
  return oAuthRequest.post('/api/v1/users', body)
}

export const update = (id, body) => {
  return oAuthRequest.put(`/api/v1/users/${id}`, body)
}

export const destroy = (id) => {
  return oAuthRequest.delete(`/api/v1/users/${id}`)
}
